<script setup>
import { useI18n } from "vue-i18n";
const { t, locale } = useI18n();
import { useLoginPopUp } from "@/stores/login-popup-visibility";

const localePath = useLocalePath();

const store = useLoginPopUp();
const authenticated = useCookie('authenticated')
const items = [
    {
        label: t('home.faqs.items.itemOne.label'),
        content: t('home.faqs.items.itemOne.content'),
        defaultOpen: true,
        slot: 'item-1'
    },
    {
        label: t('home.faqs.items.itemTwo.label'),
        content: t('home.faqs.items.itemTwo.content'),
        slot: 'item-2'
    },
    {
        label: t('home.faqs.items.itemThree.label'),
        content: t('home.faqs.items.itemThree.content'),
        slot: 'item-3'
    },
    {
        label: t('home.faqs.items.itemFour.label'),
        content: t('home.faqs.items.itemFour.content'),
        slot: 'item-4'
    },
];
</script>
<template>
    <div class="container py-10 md:py-14 px-5 mt-10">
        <div
            class="mt-12 text-center text-brand-secondary pb-6 font-extrabold text-xl leading-6 lg:text-3xl lg:leading-9">
            {{ t('home.faqs.title') }}
        </div>

        <UAccordion v-if="locale == 'es'" color="white" variant="ghost" size="xl" :items="items" open-icon="i-heroicons-plus"
            close-icon="i-heroicons-minus">
            <template #default="{ item, index, open }">
                <UButton color="white" variant="ghost"
                    class="transform text-base font-semibold text-brand-secondary px-0 text-left"
                    :ui="{ rounded: 'rounded-none', padding: { sm: 'py-3 px-7' } }">
                    <template #trailing>
                        <UIcon name="i-heroicons-chevron-right-20-solid"
                            class="ms-auto h-5 w-5 transform transition-transform duration-200"
                            :class="[open && 'rotate-90']" />
                    </template>
                    {{ item.label }}
                </UButton>
            </template>
            <template #item="{ item }">
                <p class="text-gray-900">
                    {{ item.content }}
                </p>
            </template>

            <template #item-1>
                <div class="text-gray-900">
                    {{ t('home.faqs.items.itemOne.entry') }}
                    <ul class="list-disc px-6 mt-2">
                        <li v-if="!authenticated">{{ t('home.faqs.items.itemOne.list.itemOne') }} <span
                                @click="store.open" class="underline cursor-pointer font-bold">{{
                t('home.faqs.items.itemOne.list.linkLabelOne') }}</span></li>
                        <li v-else>{{ t('home.faqs.items.itemOne.list.itemOne') }} <nuxt-link
                                :to="localePath('/profile')" class="underline font-bold">{{
                t('home.faqs.items.itemOne.list.linkLabelOne') }}</nuxt-link></li>
                        <li>{{ t('home.faqs.items.itemOne.list.itemTwo') }}
                            <nuxt-link :to="localePath(t('home.faqs.items.itemOne.list.linkTwo'))" class="underline font-bold">{{
                t('home.faqs.items.itemOne.list.linkLabelTwo') }}</nuxt-link>
                        </li>
                    </ul>
                </div>
            </template>
            <template #item-2>
                <div class="text-gray-900">
                    <div class="text-gray-900">
                        {{ t('home.faqs.items.itemTwo.entry') }}
                        <ul class="list-disc px-6 mt-2">
                            <li v-if="!authenticated">{{ t('home.faqs.items.itemTwo.list.itemOne') }} <span
                                    @click="store.open" class="underline cursor-pointer font-bold">{{
                t('home.faqs.items.itemTwo.list.linkLabelOne') }}</span></li>
                            <li v-else>{{ t('home.faqs.items.itemTwo.list.itemOne') }} <nuxt-link
                                    :to="localePath('/profile')" class="underline cursor-pointer font-bold">{{
                t('home.faqs.items.itemTwo.list.linkLabelOne') }}</nuxt-link></li>
                            <li>{{ t('home.faqs.items.itemTwo.list.itemTwoPart1') }}
                                <nuxt-link :to="localePath(t('home.faqs.items.itemTwo.list.linkTwoPart1'))" class="underline font-bold">{{
                t('home.faqs.items.itemTwo.list.linkLabelTwoPart1') }}</nuxt-link> {{
                t('home.faqs.items.itemTwo.list.itemTwoPart2') }}
                            </li>
                            <li>{{ t('home.faqs.items.itemTwo.list.itemThree') }}
                                <nuxt-link :to="localePath(t('home.faqs.items.itemTwo.list.linkThree'))" class="underline font-bold">{{
                t('home.faqs.items.itemTwo.list.linkLabelThree') }}</nuxt-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </template>
            <template #item-3>
                <div class="text-gray-900">
                    {{ t('home.faqs.items.itemThree.entry') }}
                    <ul class="list-disc px-6 my-2">
                        <li>{{ t('home.faqs.items.itemThree.list.itemOne') }} <nuxt-link
                                :to="localePath(t('home.faqs.items.itemThree.list.linkOne'))" class="underline font-bold">{{
                t('home.faqs.items.itemThree.list.linkLabelOne') }}</nuxt-link></li>
                        <li>{{ t('home.faqs.items.itemThree.list.itemTwo') }}</li>
                    </ul>
                    {{ t('home.faqs.items.itemThree.closingNote') }}
                </div>
            </template>
            <template #item-4>
                <div class="text-gray-900">
                    {{ t('home.faqs.items.itemFour.content') }}
                    <nuxt-link :to="localePath(t('home.faqs.items.itemFour.linkOne'))" class="underline font-bold">{{
                        t('home.faqs.items.itemFour.linkLabelOne') }}</nuxt-link>
                    {{ t('home.faqs.items.itemFour.closingNote') }}
                </div>
            </template>
        </UAccordion>

        <UAccordion v-else color="white" variant="ghost" size="xl" :items="items" open-icon="i-heroicons-plus"
            close-icon="i-heroicons-minus">
            <template #default="{ item, index, open }">
                <UButton color="white" variant="ghost"
                    class="transform text-base font-semibold text-brand-secondary px-0 text-left"
                    :ui="{ rounded: 'rounded-none', padding: { sm: 'py-3 px-7' } }">
                    <template #trailing>
                        <UIcon name="i-heroicons-chevron-right-20-solid"
                            class="ms-auto h-5 w-5 transform transition-transform duration-200"
                            :class="[open && 'rotate-90']" />
                    </template>
                    {{ item.label }}
                </UButton>
            </template>
            <template #item="{ item }">
                <p class="text-gray-900">
                    {{ item.content }}
                </p>
            </template>

            <template #item-1>
                <div class="text-gray-900">
                    É fácil e totalmente grátis. Primeiro, deves inscrever-te no novo Club.
                    <ul class="list-disc px-6 mt-2">
                        <li v-if="!authenticated">Se já tens conta, faz login e aproveita todas as vantagens do Club acedendo à tua área pessoal <span
                                @click="store.open" class="underline cursor-pointer font-bold">tua área pessoal.</span></li>
                        <li v-else>Se já tens conta, faz login e aproveita todas as vantagens do Club acedendo à tua área pessoal <nuxt-link
                                :to="localePath('/profile')" class="underline font-bold">tua área pessoal.</nuxt-link></li>
                        <li>Se ainda não tens conta, regista-te preenchendo os teus dados pessoais
                            <nuxt-link :to="localePath('register')" class="underline font-bold">aqui:</nuxt-link>
                        </li>
                    </ul>
                </div>
            </template>
            <template #item-2>
                <div class="text-gray-900">
                    <div class="text-gray-900">
                        Para saberes se já fazes parte do Family Club da Toys”R”Us e Prénatal, podes fazê-lo da seguinte forma
                        <ul class="list-disc px-6 mt-2">
                            <li v-if="!authenticated">Acede à tua área pessoal do Club com o teu e-mail. Vais receber um e-mail para acederes diretamente ao   <span
                                    @click="store.open" class="underline cursor-pointer font-bold">teu perfil
                                    de cliente</span></li>
                            <li v-else>Acede à tua área pessoal do Club com o teu e-mail. Vais receber um e-mail para acederes diretamente ao    <nuxt-link
                                    :to="localePath('/profile')" class="underline cursor-pointer font-bold">teu perfil de cliente</nuxt-link></li>
                            <li> Se já foste cliente anteriormente mas não associaste um e-mail à tua conta, indica os dados correspondentes em incidências Family Club para poderes recuperar e ativar 
                                <nuxt-link :to="localePath(t('home.faqs.items.itemTwo.list.linkTwoPart1'))" class="underline font-bold">o acesso.</nuxt-link>
                            </li>
                            <li>Se já foste cliente em algum momento e não te lembras dos dados associados, entra em contacto connosco através deste formulário, indicando os dados necessários.
                                <nuxt-link :to="localePath(t('home.faqs.items.itemTwo.list.linkThree'))" class="underline font-bold">indicando os dados necessários</nuxt-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </template>
            <template #item-3>
                <div class="text-gray-900">
                    Se durante o registo não conseguires avançar para o próximo passo, mesmo tendo preenchido corretamente todos os dados, recomendamos que entres em contacto connosco.
                    <ul class="list-disc px-6 my-2">
                        <li> Podes fazê-lo de duas formas:  </li>
                        <li>{{ t('home.faqs.items.itemThree.list.itemOne') }} <nuxt-link
                                :to="localePath(t('home.faqs.items.itemThree.list.linkOne'))" class="underline font-bold">{{
                t('home.faqs.items.itemThree.list.linkLabelOne') }}</nuxt-link></li>
                        <li>{{ t('home.faqs.items.itemThree.list.itemTwo') }}</li>
                    </ul>
                    {{ t('home.faqs.items.itemThree.closingNote') }}
                </div>
            </template>
            <template #item-4>
                <div class="text-gray-900">
                    <ul class="list-disc px-6 my-2">
                        <li>Se já passaram mais de 20 minutos e não recebeste o e-mail de confirmação da conta, recomendamos que verifiques primeiro a tua caixa de SPAM ou correio não solicitado. </li>
                        <li>Se não o encontrares lá, tenta inscrever-te novamente passados alguns minutos. </li>
                        <li>Se ainda assim não receberes, por favor, entra em contacto connosco através de <nuxt-link :to="localePath(t('home.faqs.items.itemFour.linkOne'))" class="underline font-bold">incidências Family Club.</nuxt-link>  </li>
                    </ul>
                        Obrigado e pedimos desculpa pelo incómodo, em breve poderás usufruir da tua conta.
                </div>
            </template>
        </UAccordion>
    </div>
</template>